<td class="product-section">
  <div class="product-name-column">
    <va-icon [diameter]="32" [iconName]="activatablePackage.name" [iconUrl]="activatablePackage.icon"></va-icon>
    <p>{{ activatablePackage.name }}</p>
  </div>
</td>
<td>
  <!--Since we don't want to display the packages pricing, this td is left blank-->
</td>
